export default {
	'stores-are-being-brought-in': 'Depo getiriliyor'
}